// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__L8Srn {
    box-sizing: border-box;
    display: flex;
    /* justify-content: flex-start; */
    align-items: center;
    width: 100%;
    height: 100%;

    box-sizing: border-box;
    display: flex;
    padding: 0 10px;
    /* justify-content: flex-end; */
    align-items: flex-end;
    margin-bottom: 10px;
    width: 100%;
    height: 100%;

}

.style_link__p-n7a {
    margin: 0px !important;
}

/* \$mainPinkColor: #E4435A;
\$mediumPinkColor: #F19AA6;
\$lightPinkColor: #f5ccc2; */
/* \$mainGreenColor: #075B52;
\$mediumGreenColor: #0e8f82;
\$lightGreenColor: #78E5DA; */
/* \$mainBlueColor: #2291C9;
\$mediumBlueColor: #3d85a9;
\$lightBlueColor: #607EAA; */
.style_image__Lrduw {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.style_text__wAxqR {
    /* color: #000; */
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.style_container__L8Srn p {
    margin: 0px;

    margin-left: 15px;
    direction: ltr;
    word-break: break-all;
}

.style_image__Lrduw img {
    max-width: 100% !important;
    min-width: unset !important;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/FileContent/style.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,aAAa;IACb,iCAAiC;IACjC,mBAAmB;IACnB,WAAW;IACX,YAAY;;IAEZ,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,+BAA+B;IAC/B,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;2BAE2B;AAC3B;;4BAE4B;AAC5B;;2BAE2B;AAC3B;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;;IAEX,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B","sourcesContent":[".container {\n    box-sizing: border-box;\n    display: flex;\n    /* justify-content: flex-start; */\n    align-items: center;\n    width: 100%;\n    height: 100%;\n\n    box-sizing: border-box;\n    display: flex;\n    padding: 0 10px;\n    /* justify-content: flex-end; */\n    align-items: flex-end;\n    margin-bottom: 10px;\n    width: 100%;\n    height: 100%;\n\n}\n\n.link {\n    margin: 0px !important;\n}\n\n/* $mainPinkColor: #E4435A;\n$mediumPinkColor: #F19AA6;\n$lightPinkColor: #f5ccc2; */\n/* $mainGreenColor: #075B52;\n$mediumGreenColor: #0e8f82;\n$lightGreenColor: #78E5DA; */\n/* $mainBlueColor: #2291C9;\n$mediumBlueColor: #3d85a9;\n$lightBlueColor: #607EAA; */\n.image {\n    width: 45px;\n    height: 45px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.text {\n    /* color: #000; */\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.container p {\n    margin: 0px;\n\n    margin-left: 15px;\n    direction: ltr;\n    word-break: break-all;\n}\n\n.image img {\n    max-width: 100% !important;\n    min-width: unset !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__L8Srn`,
	"link": `style_link__p-n7a`,
	"image": `style_image__Lrduw`,
	"text": `style_text__wAxqR`
};
export default ___CSS_LOADER_EXPORT___;
